import type { PublicPuzzle, UserNotification, UserProfile } from '@/utils/util_types';
import { authenticatedRequest } from '@/services/puzzle-chat';
import { applyMultiLangToPuzzle } from '@/utils/util_puzzles';

export const PROFILE_AVATARS = [
    'https://aispg-res.tos-cn-hongkong.volces.com/portrait01.webp',
    'https://aispg-res.tos-cn-hongkong.volces.com/portrait02.webp',
    'https://aispg-res.tos-cn-hongkong.volces.com/portrait03.webp',
    'https://aispg-res.tos-cn-hongkong.volces.com/portrait04.webp',
    'https://aispg-res.tos-cn-hongkong.volces.com/portrait05.webp',
    'https://aispg-res.tos-cn-hongkong.volces.com/portrait06.webp',
    'https://aispg-res.tos-cn-hongkong.volces.com/portrait07.webp',
    'https://aispg-res.tos-cn-hongkong.volces.com/portrait09.webp',
    'https://aispg-res.tos-cn-hongkong.volces.com/portrait10.webp',
] as const;

export async function loadProfile(): Promise<UserProfile> {
    const response = await authenticatedRequest<{ profile: UserProfile }>('/api/profile');
    return response.profile;
}

export async function updateProfile(changes: { username?: string; avatar?: string }): Promise<UserProfile> {
    const response = await authenticatedRequest<{ profile: UserProfile }>('/api/profile', {
        method: 'PATCH',
        body: JSON.stringify(changes),
    });
    return response.profile;
}

export async function checkIn(): Promise<{ resultCode: string; profile: UserProfile | null }> {
    const response = await authenticatedRequest<{ result_code: string; profile: UserProfile | null }>('/api/profile/check-in', { method: 'POST' });
    return { resultCode: response.result_code, profile: response.profile };
}

export async function requestAccountDeletion() {
    await authenticatedRequest<{ status: string }>('/api/profile', { method: 'DELETE' });
}

export async function revokeAccountDeletion(): Promise<UserProfile> {
    const response = await authenticatedRequest<{ profile: UserProfile }>('/api/profile/revoke-deletion', { method: 'POST' });
    return response.profile;
}

export async function loadLikedPuzzles(language: string) {
    const response = await authenticatedRequest<{ puzzles: PublicPuzzle[] }>('/api/profile/liked-puzzles');
    return response.puzzles.map((puzzle) => applyMultiLangToPuzzle(puzzle, language));
}

export async function loadNotifications() {
    return authenticatedRequest<{ notifications: UserNotification[]; unread_count: number }>('/api/notifications');
}

export async function markNotificationRead(notificationId: string) {
    await authenticatedRequest<{ read: boolean }>(`/api/notifications/${encodeURIComponent(notificationId)}`, { method: 'PATCH' });
}

export async function markAllNotificationsRead() {
    await authenticatedRequest<{ read: boolean }>('/api/notifications/read-all', { method: 'POST' });
}
